import { ReactNode } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { GenericCardProps } from 'types';
import useAuth from 'hooks/useAuth';
import { FeatureFlags, PermissionTypeEnum } from 'types/user-profile';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

export interface NavGroupProps {
    item: {
        id?: string;
        type?: string;
        icon?: GenericCardProps['iconPrimary'];
        children?: NavGroupProps['item'][];
        title?: ReactNode | string;
        caption?: ReactNode | string;
        color?: 'primary' | 'secondary' | 'default' | undefined;
      //  adminOnly?: boolean; 
        systemAdminOnly?: boolean;
        developerOnly?: boolean;
        requeredPermission?:PermissionTypeEnum[]; 
        hideFromPermission?:PermissionTypeEnum[]; 
        feature?:FeatureFlags;
    };
}

const NavGroup = ({ item }: NavGroupProps) => {
    const theme = useTheme();
    const { user } = useAuth();

    // menu list collapse & items
    // 
    const filterAllowedMenus = (curr_menu:any) => {

        if(curr_menu.developerOnly){
            if(!user || !user.isDeveloper){
                return false;
            }
        }
        if(curr_menu.systemAdminOnly){
            if(!user || !user.isSystemAdmin){
                return false;
            }
        }
        if(curr_menu.hideFromPermission != undefined){
            if(user && user.permissions) {
                const has_hide_permissions = user.permissions.some((permission) => curr_menu.hideFromPermission.includes(permission));
                if(has_hide_permissions) {
                    return false;
                }
            }
        }
        
        if(curr_menu.requeredPermission != undefined){
            if(!user || !user.permissions) {
                 return false;
            } 
            const has_permissions = user.permissions.some((permission) => curr_menu.requeredPermission.includes(permission));
            if(!has_permissions){
                return false;
            }
        }

        if(curr_menu.feature != undefined){
             if(!user || !user.features?.includes(curr_menu.feature)){
                return false;
            }
        }
        
        if(curr_menu.children){
            
            const allowed_child_menues = curr_menu.children.filter(filterAllowedMenus).length;
            if(allowed_child_menues == 0){
               
                return false;
            }
        }
        return true;
    } 
                                                  
    const items = item.children?.filter(filterAllowedMenus).map((menu) => {

        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
        {items && items.length > 0 && <>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 1.25 }} />
            </>}
        </>
    );
};

export default NavGroup;
